<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap py-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
                <v-icon color="#9B8DFD">mdi-account</v-icon>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <router-link :to="'/adminList'" style="text-decoration: none">
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >View Admin</span
                  >
                </router-link>
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link :to="'/adminAdd'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >Add Admin</span
                >
              </router-link>
            </v-flex></v-layout
          >
          <v-card-text>
            <v-layout justify-start wrap>
              <v-flex xs12 sm6 md8 pa-2>
                <v-select
                  v-model="school"
                  dense
                  style="font-family: nunitosanssemibold"
                  outlined
                  label="School"
                  :items="schoolArray"
                  item-text="name"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md4 pb-8 pa-2 text-right>
                <v-btn
                  @click="getSearch()"
                  dark
                  block
                  style="font-family: nunitosanssemibold"
                  color="#9B8DFD"
                  >SEARCH</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-layout justify-center wrap pt-10 pb-5 v-if="admin.length > 0">
          <v-flex xs12>
            <span style="font-family: nunitosansbold; font-size: 20px"
              >View Admin</span
            ><br />
            <v-layout justify-start wrap>
              <v-flex
                xs12
                sm6
                md4
                lg4
                xl4
                v-for="(list, index) in admin"
                :key="index"
                pa-2
              >
                <v-card>
                  <v-card-text>
                    <v-layout justify-center wrap>
                      <!-- <v-flex xs4 sm4 md4 lg3 pt-2>
                        <v-avatar style="cursor: pointer" size="48">
                          <v-img
                            width="40px"
                            :src="mediaURL + list.image"
                          ></v-img>
                        </v-avatar>
                      </v-flex> -->
                      <v-flex xs10 sm10 md10 lg9>
                        <span
                          v-if="list.school"
                          style="color: #000000; font-family: nunitosansbold"
                          >{{ list.school.name }}</span
                        ><br />
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                          "
                          >{{ list.name }}</span
                        ><br />
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                          "
                          >{{ list.phone }}</span
                        >
                      </v-flex>
                      <v-flex xs1 pt-2>
                        <v-icon
                          small
                          class="mr-2"
                          outlined
                          block
                          @click="editSlider(list)"
                        >
                          mdi-pencil
                        </v-icon>
                      </v-flex>
                      <v-flex xs1 pt-2>
                        <v-dialog v-model="list.delete" max-width="600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="15" v-on="on" v-bind="attrs"
                              >mdi-close</v-icon
                            >
                          </template>
                          <v-card>
                            <v-card-title
                              style="font-family: nunitosansregular"
                            >
                              Are you sure you want to delete this admin?
                            </v-card-title>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="list.delete = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="deleteItem(list._id)"
                                >OK</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-dialog v-model="editdialog" max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="headline">Edit Admin</span>
                </v-card-title>
                <v-card-text>
                  <v-layout justify-center wrap>
                    <v-flex xs12 pa-2>
                      <v-text-field
                        style="font-family: nunitosansregular"
                        outlined
                        dense
                        v-model="editingitem.name"
                        label="Name of the Admin"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 pa-2>
                      <v-text-field
                        style="font-family: nunitosansregular"
                        outlined
                        dense
                        v-model="editingitem.phone"
                        label="Phone of the Admin"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 pa-2 v-if="editingitem.email">
                      <v-text-field
                        style="font-family: nunitosansregular"
                        outlined
                        dense
                        v-model="editingitem.email"
                        label="Email of the Admin"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 pa-2>
                      <v-select
                        v-model="editingitem.school"
                        dense
                        style="font-family: nunitosanssemibold"
                        outlined
                        label="School"
                        readonly
                        :items="schoolArray"
                        item-text="name"
                        item-value="_id"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 pa-2 v-if="editingitem.gender">
                      <v-select
                        dense
                        label="Gender"
                        outlined
                        class="text"
                        v-model="editingitem.gender"
                        hide-details
                        :items="genders"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs12 pa-2 v-if="editingitem.dob">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="editingitem.dob"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editingitem.dob"
                            label="DOB"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editingitem.dob"
                          max="2000-01-1"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(editingitem.dob)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 pa-2 v-if="editingitem.address">
                      <v-textarea
                        style="font-family: nunitosansregular"
                        outlined
                        dense
                        v-model="editingitem.address"
                        label="Address of the Admin"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="editdialog = false">
                    Close
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="edit(editingitem._id)"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center wrap py-8>
          <v-flex xs12 text-center>
            <span
              style="
                font-family: nunitosansregular;
                color: #000000;
                font-size: 14px;
              "
              >Oops !! No data found..</span
            >
          </v-flex>
        </v-layout>
        <div class="text-center" v-if="pages > 1">
          <v-pagination
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#9B8DFD"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      menu: false,
      currentPage: 1,
      pages: 0,
      count: 4,
      totalData: 0,
      standard: "",
      admin: [],
      studentList: [],
      page: 1,
      school: "",
      formDataCover: new FormData(),
      classArray: [],
      image: null,
      imagePreview: "",
      showPreview: false,
      file: null,
      editingitem: [],
      schoolArray: [],
      editdialog: false,
      genders: ["Male", "Female", "Other"],
    };
  },
  mounted() {
    this.getAdmin();
    this.getSchool();
  },
  methods: {
    getSearch() {
      this.appLoading = true;
      if (this.currentPage > 1) this.currentPage = 1;
      axios({
        method: "GET",
        url: "/school/admin/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          school: this.school,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.admin = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getAdmin() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/school/admin/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          school: this.school,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.admin = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSchool() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/school/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.schoolArray = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      //   this.editingitem.dob=this.editingitem.dob.slice(0,10)
      this.editdialog = true;
    },
    edit() {
      this.appLoading = true;
      var user = {};
      user["name"] = this.editingitem.name;
      user["address"] = this.editingitem.address;
      user["email"] = this.editingitem.email;
      user["phone"] = this.editingitem.phone;
      user["dob"] = this.editingitem.dob;
      user["gender"] = this.editingitem.gender;
      user["id"] = this.editingitem;
      axios({
        method: "POST",
        url: "/school/admin/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.getAdmin();
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r;
      axios({
        url: "/school/admin/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getSchool();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>